import routes from '@modules/site/site-routes';
import store from '@modules/site/site-store';

export default {
  routes,
  store,
};
